import axiosInstance from "@/middlewares/Routing.middleware";
import { Permission } from "../models/Permission.model";

export async function GetPermissions(): Promise<Permission[]> {
  return (await axiosInstance.get("/permissions")).data;
}
